import { ForwardedRef, RefObject, useRef } from 'react';

/** Создает все рефы для управления различными частями поведения автокомплита.
 * Принимает forwardRef из определения компонента.
 * Ниже комментарии к каждому рефу.
 */
export function useRefs(_ref: ForwardedRef<HTMLInputElement>) {
  /** 1. Реф для определения внешней области ( для useClickOutside ) */
  const containerRef = useRef<HTMLDivElement>(null);
  /** 2. Внутренний реф, на случай если не передан внешний (ref) - нужен для
   * программным управлением видимого value без создания стейта
   */
  const innerRef = useRef<HTMLInputElement>(null);
  /** 3. Общий реф для управления value */
  const ref = (_ref || innerRef) as RefObject<HTMLInputElement>;

  const setRefValue = (value: string) => {
    if (ref.current) {
      ref.current.value = value;
    }
  };

  return {
    containerRef,
    ref,
    setRefValue
  };
}
